import config from '../../config';
import React, { Component } from 'react';
import Edito from '../Edito/Edito';
import Element from '../Element/Element';
import Skew from '../Skew/Skew';
import Video from '../Video/Video';
import Masthead from '../Masthead/Masthead';
import './Board.css';


function getSizes() {
    var width = Math.min(document.documentElement.clientWidth, config.ratio.width),
		height = Math.min(document.documentElement.clientHeight, config.ratio.height),
		mobile = false,
        slideWidth = width,
        boardHeight = height,
        boardTop = 0;

	if (width < config.ratio.width) {
		mobile = true;
	}
    if (width / height < config.ratio.width / config.ratio.height) {
        boardHeight = config.ratio.height * width / config.ratio.width;
        boardTop = (document.documentElement.clientHeight - boardHeight) / 2;
	}

    return {
        slideWidth: slideWidth,
        boardHeight: boardHeight,
		boardTop: boardTop,
		mobile : mobile
    }
}

export default class Board extends Component {

    constructor(props) {
        super(props);

        this.state = {
            slideWidth:getSizes().slideWidth,
            boardHeight:getSizes().boardHeight,
			boardTop:getSizes().boardTop,
			mobile:getSizes().mobile
        };
    }

    componentDidMount() {
        var _this = this;
        window.addEventListener('resize', function () {
            _this.setState({
                slideWidth:getSizes().slideWidth,
                boardHeight:getSizes().boardHeight,
				boardTop:getSizes().boardTop,
				mobile:getSizes().mobile
            });
        });
    }

    render() {
		var mobile = this.state.mobile;
        return (
            <div id="board" className="Board" style={{marginTop:this.state.boardTop, left:0,  minWidth:this.state.slideWidth, height: this.state.boardHeight}}>

                {/* Intro */}
                <div className="Board__slide">
                    <Edito content={this.props.datas.text["intro"].zone1} positionTop="15%"></Edito>
                    <Element name="BG_vagues_dark.png" index="m1" positionLeft="0"></Element>
                    <Element name="bouee_jaune.png" index="p1" positionLeft="50%"></Element>
                </div>
                <div className="Board__slide">
                    <Edito content={this.props.datas.text["intro"].zone2} positionTop="25%"></Edito>
                </div>
                <div className="Board__slide">
                    <Edito content={this.props.datas.text["intro"].zone3} positionTop="35%"></Edito>
                </div>
                <div className="Board__slide">
                    <Element name="blueprint.png" index="p1" positionLeft="0"></Element>
                </div>

                {/* Studio */}
                <div className="Board__slide">
                    <Skew position="left" top="91baff" bottom="a5c7ff" ></Skew>
                    <Element name="titre_studio.png" index="p1" positionLeft="0"></Element>
                    <Element name="photo_calin.png" index="p1" positionLeft="0"></Element>
                    <Element name="BG_zigouigoui1.png" index="p2" positionLeft="0"></Element>
                </div>
                <div className="Board__slide blue1">
                    <Edito content={this.props.datas.text["studio"].zone1} positionTop="15%" positionLeft="60%"></Edito>
                </div>
                <div className="Board__slide blue1">
                    <Edito content={this.props.datas.text["studio"].zone2} positionTop="25%"></Edito>
                </div>
                <div className="Board__slide blue1">
                    <Element name="eau_libre.png" index="p1" positionLeft="0"></Element>
                </div>

                <div className="Board__slide blue1">
                    <Edito content={this.props.datas.text["studio"].zone3} positionBottom="5%"></Edito>
                    <Element name="photo_piscine.png" index="p1" positionLeft="0"></Element>
                </div>
                <div className="Board__slide blue1">
                    <Element name="quote1.png" index="p1" positionLeft="0"></Element>
                    <Edito content={this.props.datas.text["studio"].zone4} positionTop="10%"></Edito>
                </div>
                <div className="Board__slide blue1">
                    <Element name="palmares.png" index="p1" positionLeft="0"></Element>
                </div>
                <div className="Board__slide blue1">
                    <Element name="axel2_bg.gif" index="p1" positionLeft="0"></Element>
                    <Edito content={this.props.datas.text["studio"].zone5} positionBottom="15%"></Edito>
                </div>
                <div className="Board__slide blue1">
                    <Edito content={this.props.datas.text["studio"].zone6} positionTop="15%"></Edito>
                    <Element name="quote2.png" index="p1" positionLeft="0"></Element>
                </div>

                <div className="Board__slide blue1">
                    <Video id="x76xzfm" positionTop="25%" maxHeight={config.ratio.width / 1.778} ratio="1.778"></Video>
                </div>

                {/* Voiture */}
                <div className="Board__slide blue1">
                    <Skew position="left" top="649dfc" bottom="7eadfc" ></Skew>
                    <Element name="titre_voiture.png" index="p1" positionLeft="0"></Element>
                    <Element name="clio.png" index="p1" positionLeft="30%"></Element>
                </div>
                <div className="Board__slide blue2">
                    <Edito content={this.props.datas.text["voiture"].zone1} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide blue2">
                    <Element name="pompe.png" index="p1" positionLeft="0"></Element>
                    <Edito content={this.props.datas.text["voiture"].zone2} positionTop="50%"></Edito>
                </div>
                <div className="Board__slide blue2">
                    <Edito content={this.props.datas.text["voiture"].zone3} positionTop="20%"></Edito>
                    <Element name="BG_zigouigoui2.png" index="p2" positionLeft="0"></Element>
                </div>
                <div className="Board__slide blue2">
                    <Video id="x76xjln" positionTop="50%" maxHeight={config.ratio.width / 1.778} ratio="1.778"></Video>
                </div>
                <div className="Board__slide blue2">
                    <Edito content={this.props.datas.text["voiture"].zone4} positionBottom="20%"></Edito>
                </div>
                <div className="Board__slide blue2">
                    <Element name="quote3.png" index="p1" positionLeft="0"></Element>
                </div>
                <div className="Board__slide blue2">
                    <Edito content={this.props.datas.text["voiture"].zone5} positionTop="15%"></Edito>
                    <Element name="photos_US2.png" index="p1" positionLeft="0"></Element>
                </div>


                {/* Sauces */}
                <div className="Board__slide blue2">
                    <Skew position="left" top="3b76db" bottom="538ced" ></Skew>
                    <Element name="titre_sauces.png" index="p1" positionLeft="0"></Element>
                    <Element name="sauce1.png" index="p1" positionLeft="0"></Element>
                    <Element name="sauce2.png" index="p2" positionLeft="-20%"></Element>
                </div>
                <div className="Board__slide blue3">
                    <Edito content={this.props.datas.text["sauces"].zone1} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide blue3">
                    <Edito content={this.props.datas.text["sauces"].zone2} positionTop="15%"></Edito>
                    <Element name="BG_rocheuses1.png" index="m2" positionLeft="50%"></Element>
                    <Element name="BG_rocheuses2.png" index="m1" positionLeft="0"></Element>
                </div>
                <div className="Board__slide blue3">
                    <Element name="photos_US1.png" index="p1" positionLeft="0"></Element>
                </div>

                <div className="Board__slide blue3">
                    <Element name="BG_rocheuses3.png" index="m1" positionLeft="0"></Element>
                    <Edito content={this.props.datas.text["sauces"].zone3} positionTop="30%"></Edito>
                </div>
                <div className="Board__slide blue3">
                    <Edito content={this.props.datas.text["sauces"].zone4} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide blue3">
                    <Element name="vegas.png" index="p1" positionLeft="0"></Element>
                </div>

                {/* Jeux vidéo */}
                <div className="Board__slide blue3">
                    <Skew position="left" top="031f4f" bottom="062a68" ></Skew>
                    <Element name="titre_jeux_video.png" index="p1" positionLeft="0"></Element>
                    <Element name="gaming_bis.png" index="p1" positionLeft="20%"></Element>
                </div>
                <div className="Board__slide white blue4">
                    <Edito content={this.props.datas.text["jv"].zone1} positionTop="15%"></Edito>
                    <Element name="BG_jeux_video.png" index="m2" positionLeft="0"></Element>
                </div>
                <div className="Board__slide white blue4">
                    <Element name="quote4.png" index="p1" positionLeft="0"></Element>
                </div>
                <div className="Board__slide white blue4">
                    <Edito content={this.props.datas.text["jv"].zone2} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide white blue4">
                    <Edito content={this.props.datas.text["jv"].zone3} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide blue4">
                    <Video id="x768sjg" positionTop="30%" maxHeight={config.ratio.width / 1.778} ratio="1.778"></Video>
                </div>
                <div className="Board__slide white blue4">
                    <Edito content={this.props.datas.text["jv"].zone4} positionTop="15%"></Edito>
                </div>

                {/* Livre */}
                <div className="Board__slide blue4">
                    <Skew position="left" top="021330" bottom="031e4c" ></Skew>
                    <Element name="titre_livre.png" index="p1" positionLeft="0"></Element>
                    <Element name="livre.png" index="p1" positionLeft="0"></Element>
                </div>
                <div className="Board__slide white blue5">
                    <Element name="BG_vagues_light.png" index="m1" positionLeft="0"></Element>
                    <Edito content={this.props.datas.text["livre"].zone1} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide blue5">
                    <Element name="quote5.png" index="p1" positionLeft="0"></Element>
                </div>
                <div className="Board__slide white blue5">
                    <Edito content={this.props.datas.text["livre"].zone2} positionTop="20%"></Edito>
                    <Element name="bouee_rouge.png" index="p1" positionLeft="0"></Element>
                </div>
                <div className="Board__slide blue5">
                    <Video id="x76bm0u" positionTop="30%" maxHeight={config.ratio.width / 1.778} ratio="1.778"></Video>
                </div>
                <div className="Board__slide white blue5">
                    <Element name="axel_bg.gif" index="p1" positionLeft="-10%"></Element>
                    <Edito content={this.props.datas.text["livre"].zone3} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide blue5">
                    <Element name="quote6.png" index="p1" positionLeft="-10%"></Element>
                </div>
                <div className="Board__slide blue5">
                    <Video id="x76ileh" positionTop="30%" maxHeight={config.ratio.width / 1.778} ratio="1.778"></Video>
                </div>
                <div className="Board__slide white blue5">
                    <Edito content={this.props.datas.text["livre"].zone4} positionTop="15%"></Edito>
                </div>

                {/* Chute */}
                <div className="Board__slide blue5">
                    <Skew position="left" top="000000" bottom="001842" ></Skew>
                    <Element name="photo_coree.png" index="p1" positionLeft="0"></Element>
                </div>
                <div className="Board__slide blue6">
                    <Element name="axel_mag_coree.png" index="p1" positionLeft="0"></Element>
                </div>
                <div className="Board__slide white blue6">
                    <Edito content={this.props.datas.text["chute"].zone1} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide blue6">
                    <Video id="x76bm0t" positionTop="60%" maxHeight={config.ratio.width / 1.778} ratio="1.778"></Video>
                </div>

                <div className="Board__slide blue6">
                    <Masthead />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Board/Board.js